import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ProductList from '../context/ProductList';
import Navbar from '../components/Navbar';
import Navbar2 from '../components/Navbar2';
import './CategoryPage.css';

function CategoryPage() {

    const { category } = useParams();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const decodedCategory = decodeURIComponent(category);
                console.log('Fetching products for:', decodedCategory);
                const response = await fetch(`http://localhost:3001/api/products/category/${decodedCategory}`);
                const data = await response.json();
                setProducts(data);
                setLoading(false);
            } catch (error) {
                console.error("Error fetching products:", error);
                setLoading(false);
            }
        }
        fetchProducts();
    }, [category]);


    if (loading) {
        return (
            <div className="category-page-container">
                <Navbar />
                <div className="sticky-navbar">
                    <Navbar2 />
                </div>
                <div className="loading-container">
                    <div className="spinner" role="status"></div>
                </div>
            </div>
        );
    }
  return (
    <div className='category-page-container'>
        <Navbar />
            <div className="sticky-navbar">
                <Navbar2 />
            </div>
            <div className="category-content">
                <h1 className="category-title">{category}</h1>
                <ProductList products={products} />
            </div>
    </div>
  )
}

export default CategoryPage